import { Component } from "react";
import { Banner } from "./Primitives.jsx";

export default class ContentBoundary extends Component {
  state = { failed: false, error: null };

  static getDerivedStateFromError(error) {
    return { failed: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Could not open workspace content.", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className={this.props.errorClassName}>
        <div className="card content-error">
          <Banner tone="vlow" title={this.props.title ?? "This view could not open."}>
            {this.state.error instanceof Error ? this.state.error.message : String(this.state.error)}
          </Banner>
          <p className="muted">Reload the page to try again. Any unsaved inputs on this page will be reset.</p>
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
